import {useMutation} from "@tanstack/react-query";
import {ApiConfig} from "@/config/api.config.ts";
import axios, {AxiosError} from "axios";
import {ProblemDetails} from "@/@types/base.types.ts";
import {
    LoginRequestDto,
    LoginResponseDto,
    TwoFactorAuthResponseDto
} from "@/@types/auth.types.ts";
import {useState} from "react";
import {ErrorKey, getErrorKey} from "@/config/apiErrorKeys.ts";

type AuthApiProps = {
    onError?: (errorKey: ErrorKey) => void;
    onSuccess?: (result: LoginResponseDto | TwoFactorAuthResponseDto) => void;
}

export const useLoginApi = ({onError, onSuccess}: AuthApiProps) => {
    const [isLoginFailure, setLoginFailure] = useState<boolean>(false);


    const {mutateAsync: doLogin, isPending: isDoLoginWorking} = useMutation({
            mutationKey: [ApiConfig.queries.auth.queryKeys.login],
            mutationFn: async ({
                                   userName,
                                   password
                               }: LoginRequestDto): Promise<LoginResponseDto | TwoFactorAuthResponseDto> => {
                setLoginFailure(false);

                const axiosInstance = axios.create({
                    baseURL: ApiConfig.currentUrls.api,
                });
                const url = ApiConfig.currentUrls.api + ApiConfig.queries.auth.endpoints.login;
                const response = await axiosInstance.post<LoginResponseDto | TwoFactorAuthResponseDto>(url, {
                    userName,
                    password,
                });

                return response.data;
            },
            onError: async (error: AxiosError<ProblemDetails>) => {
                onError?.(getErrorKey(error));
            },
            onSuccess: async (result: LoginResponseDto | TwoFactorAuthResponseDto) => {
                onSuccess?.(result);
            }
        }
    )

    return {
        doLogin,
        isDoLoginWorking,
        isLoginFailure,
    }
}